import React from 'react'

interface CardProps {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  style?: React.CSSProperties
  padding?: 'sm' | 'md' | 'lg'
  onClick?: () => void
}

export function Card({ children, header, footer, style, padding = 'md', onClick }: Readonly<CardProps>) {
  const p = { sm: 'var(--space-2)', md: 'var(--space-3)', lg: 'var(--space-4)' }[padding]
  const Wrapper = onClick ? 'button' : 'div'
  return (
    <Wrapper onClick={onClick} style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-s)',
      overflow: 'hidden',
      ...(onClick ? { cursor: 'pointer', textAlign: 'left' as const, width: '100%', font: 'inherit', color: 'inherit' } : {}),
      ...style,
    }}>
      {header && (
        <div style={{
          padding: `var(--space-2) ${p}`,
          borderBottom: '1px solid var(--border-subtle)',
          fontSize: 'var(--text-body3-size)',
          fontWeight: 600,
          color: 'var(--text-secondary)',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
          {header}
        </div>
      )}
      <div style={{ padding: p }}>
        {children}
      </div>
      {footer && (
        <div style={{
          padding: `var(--space-15) ${p}`,
          borderTop: '1px solid var(--border-subtle)',
          background: 'var(--surface-hover)',
        }}>
          {footer}
        </div>
      )}
    </Wrapper>
  )
}
